export default function (val) {
  if (!val) return '--';
  return String(val).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}
